/* src/app/shared/contract/contract-item/contract-cgrp-off/cgrp-off-option-dialog/cgrp-off-option-dialog.component.scss */
/*# sourceMappingURL=cgrp-off-option-dialog.component.css.map */
